import { MessageSchema } from "@redotech/redo-agents-common/llm-messages";
import * as z from "zod";

const AskRedoInputSchema_ = z.object({
  messages: z.array(MessageSchema),
  currentThreadId: z.string().optional(),
  product: z.string(),
  pageContext: z.object({
    stepId: z.string(),
    stepLabel: z.string(),
    formValues: z.record(z.string(), z.unknown()).optional(),
  }),
});

const AskRedoOutputSchema_ = z.object({
  threadId: z.string(),
  messages: z.array(MessageSchema),
});

export const askRedo = {
  name: "askRedo" as const,
  input: AskRedoInputSchema_,
  output: AskRedoOutputSchema_,
};
